import {
  SET_ACTIVE_CUSTOMER,
  SET_BRANDS,
  SET_ENUMS,
  SET_COUNTRIES,
  SET_CUSTOMERS,
  SET_CUSTOMERGROUPS,
  SET_COMPANIES,
  SET_PHONECODES,
  SET_VEHICLE_LOOKUP_SEVICES,
  SET_DEFAULT_PHONECODE,
  SET_EMPLOYEES,
  SET_HEADERINFO,
  SET_HEADERINFO_FORSI,
  SET_HEADERINFO_MESSAGES,
  SET_HEADERINFO_EVALUATION,
  SET_HEADERINFO_UPDATES,
  SET_HEADERINFO_CHAINNOTIFICATION,
  SET_HEADERINFO_BOOKINGPORTALDRAFTS,
  SET_LOGINTIMER,
  // SET_UPLOADS,
  SET_PAGE_TITLE,
  SET_PAGE_TITLE_EXTRA,
  SET_POPUPS,
  SET_OVERLAYS,
  SET_SLIDEPANELS,
  SET_HEADERINFO_TASKS,
  SET_HELPICON_POPUP_UPDATES,
  SET_HEADERINFO_ORDERS,
  SET_CURRENCY_CODE,
  SET_HAS_PAINT_PARTNER,
  SET_BODY_DEFAULT_LEAD_TIME
} from '../constants'

const initialState = {
  pageTitle: {
    title: 'Apromas',
    extra: null,
    icon: null
  },
  helpIconPopupUpdates: 0,
  slidePanels: [],
  overlays: [],
  popups: [],
  loginTimer: undefined,
  uploads: [],
  brands: [],
  customers: [],
  activeCustomer: {},
  customergroups: [],
  companies: [],
  countries: [],
  employees: [],
  currencyCode: '',
  phonecodes: [],
  vehicleLookupServices: [],
  phonecode: {
    Id: 1
  },
  partSides: {
    0: 'None',
    1: 'Left',
    2: 'Right',
    3: 'Front',
    4: 'Back',
    5: 'FrontLeft',
    6: 'FrontRight',
    7: 'BackLeft',
    8: 'BackRight'

  },
  transport: [
    { Id: 1, Name: '154' },
    { Id: 3, Name: '26' },
    { Id: 2, Name: '351' }
  ],
  doors: [
    { Id: 1, Name: '' },
    { Id: 2, Name: '2' },
    { Id: 3, Name: '3' },
    { Id: 4, Name: '4' },
    { Id: 5, Name: '5' },
    { Id: -1, Name: 'ST' }
  ],
  loosePartType: [
    { Id: true, Name: '75' },
    { Id: false, Name: '76' }
  ],
  enums: {
    carSizes: {
      1: 'small',
      2: 'medium',
      3: 'large'
    },
    orderTypes: {
      1: '13360',
      2: '71',
      3: '13361',
      4: '73',
      5: '301',
      6: '785'
    },
    complaintTypes: {
      1: 'ColorDifference',
      2: 'Gloss',
      3: 'Dirt',
      4: 'Blisters',
      5: 'Runners',
      6: 'Flicker',
      7: 'Scratches',
      8: 'Chopping',
      9: 'SprayDust',
      10: 'Sinking',
      11: 'Rust',
      12: 'Other'
    }
  },
  enums_new: [],
  headerInfo: {
    Updates: [],
    ManualMerges: [],
    EconomicMatches: [],
    ForsiActive: true,
    UnreadMessages: 0,
    IncompletedTasks: 0,
    BookingPortalDrafts: [],
    ChainNotification: null,
    ForsiTokenActive: false,
    UsesForsiToken: false
  }
}

export default (state = initialState, action = {}) => {
  if (state.loginTimer === undefined) {
    let date = new Date()
    date.setSeconds(date.getSeconds() + 60)
    state.loginTimer = date
  }
  switch (action.type) {
    case SET_HELPICON_POPUP_UPDATES:
      return {
        ...state,
        helpIconPopupUpdates: action.number
      }
    case SET_SLIDEPANELS:
      return {
        ...state,
        slidePanels: action.slidePanels
      }
    case SET_OVERLAYS:
      return {
        ...state,
        overlays: action.overlays
      }
    case SET_POPUPS:
      return {
        ...state,
        popups: action.popups
      }
    case SET_PAGE_TITLE:
      return {
        ...state,
        pageTitle: action.pageTitle
      }
    case SET_PAGE_TITLE_EXTRA:
      return {
        ...state,
        pageTitle: {
          ...state.pageTitle,
          extra: action.pageTitleExtra
        }
      }
    case SET_LOGINTIMER:
      return {
        ...state,
        loginTimer: action.loginTimer
      }
    case SET_CUSTOMERS:
      return {
        ...state,
        customers: action.customers
      }
    case SET_ACTIVE_CUSTOMER:
      let activeCustomer = state.customers.find(_ => _.CustomerId === action.payload)
      if (!activeCustomer) activeCustomer = {}
      return { ...state, activeCustomer }
    case SET_CUSTOMERGROUPS:
      return {
        ...state,
        customergroups: action.customergroups
      }
    case SET_COMPANIES:
      return {
        ...state,
        companies: action.companies
      }
    case SET_EMPLOYEES:
      return {
        ...state,
        employees: action.employees
      }
    case SET_PHONECODES:
      return {
        ...state,
        phonecodes: action.phonecodes
      }
    case SET_VEHICLE_LOOKUP_SEVICES:
      return {
        ...state,
        vehicleLookupServices: action.vehicleLookupServices
      }
    case SET_DEFAULT_PHONECODE:
      return {
        ...state,
        phonecode: action.phonecode
      }
    case SET_BRANDS:
      return {
        ...state,
        brands: action.brands
      }
    case SET_ENUMS:
      return {
        ...state,
        enums_new: action.enums
      }
    case SET_COUNTRIES:
      return {
        ...state,
        countries: action.countries
      }
    case SET_HEADERINFO:
      return {
        ...state,
        headerInfo: action.headerInfo
      }
    case SET_HEADERINFO_FORSI:
      return {
        ...state,
        headerInfo: {
          ...state.headerInfo,
          ForsiTokenActive: action.ForsiTokenActive
        }
      }
    case SET_HEADERINFO_MESSAGES:
      return {
        ...state,
        headerInfo: {
          ...state.headerInfo,
          UnreadMessages: action.UnreadMessages
        }
      }
    case SET_HEADERINFO_TASKS:
      return {
        ...state,
        headerInfo: {
          ...state.headerInfo,
          IncompletedTasks: action.IncompletedTasks
        }
      }
    case SET_HEADERINFO_EVALUATION:
      return {
        ...state,
        headerInfo: {
          ...state.headerInfo,
          Updates: action.Updates
        }
      }
    case SET_HEADERINFO_UPDATES:
      return {
        ...state,
        headerInfo: {
          ...state.headerInfo,
          ManualMerges: action.ManualMerges
        }
      }
    case SET_HEADERINFO_CHAINNOTIFICATION:
      return {
        ...state,
        headerInfo: {
          ...state.headerInfo,
          ChainNotification: action.ChainNotification
        }
      }
    case SET_HEADERINFO_BOOKINGPORTALDRAFTS:
      return {
        ...state,
        headerInfo: {
          ...state.headerInfo,
          BookingPortalDrafts: action.BookingPortalDrafts
        }
      }
    case SET_HEADERINFO_ORDERS:
      return {
        ...state,
        headerInfo: {
          ...state.headerInfo,
          AssignedOrders: action.AssignedOrders
        }
      }
    case SET_CURRENCY_CODE:
      return {
        ...state,
        currencyCode: action.currencyCode
      }
    case SET_HAS_PAINT_PARTNER:
      return {
        ...state,
        hasPaintPartner: action.hasPaintPartner
      }
    case SET_BODY_DEFAULT_LEAD_TIME:
      return {
        ...state,
        bodyShopDefaultLeadTime: action.bodyShopDefaultLeadTime
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/common.js